export default __webpack_public_path__ + "static/media/ControlPanel.0e7ed9fc.png";